import React from 'react';
import { UserCircleIcon, UserGroupIcon, LocationMarkerIcon, PlusCircleIcon, UserRemoveIcon } from '../icons';
import './UserTag.css';

export type UserType = 'musician' | 'fan' | 'band' | 'venue' | 'showContributor' | 'bandMember' | 'noAccount';

export interface UserTagProps {
  type: UserType;
  onClick?: () => void;
}

const USER_TAG_CONFIG = {
  musician: {
    label: 'Musician',
    icon: UserCircleIcon,
    className: 'user-tag-musician',
  },
  fan: {
    label: 'Fan',
    icon: UserCircleIcon,
    className: 'user-tag-fan',
  },
  band: {
    label: 'Band',
    icon: UserGroupIcon,
    className: 'user-tag-band',
  },
  venue: {
    label: 'Venue',
    icon: LocationMarkerIcon,
    className: 'user-tag-venue',
  },
  showContributor: {
    label: 'Show Contributor',
    icon: PlusCircleIcon,
    className: 'user-tag-show-contributor',
  },
  bandMember: {
    label: 'Band Member',
    icon: UserGroupIcon,
    className: 'user-tag-band-member',
  },
  noAccount: {
    label: 'No User Account',
    icon: UserRemoveIcon,
    className: 'user-tag-no-account',
  },
};

export const UserTag: React.FC<UserTagProps> = ({ type, onClick }) => {
  const config = USER_TAG_CONFIG[type];
  const IconComponent = config.icon;

  return (
    <button 
      className={`user-tag ${config.className}`}
      onClick={onClick}
    >
      <IconComponent 
        size="s" 
        color="currentColor" 
        style={{ width: '14px', height: '14px' }}
      />
      <span className="user-tag-label">{config.label}</span>
    </button>
  );
};

export default UserTag;
